import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import DashboardShell from "@/components/layout/DashboardShell";
import DailySummaryCard from "@/components/DailySummaryCard";
import GateActivityCard from "@/components/GateActivityCard";
import { useT } from "@/lib/i18n";
import { Beef, Users, UserPlus, IndianRupee, ShoppingBag, Calendar } from "lucide-react";
import HelpVideoButton from "@/components/HelpVideoButton";

function Stat({ icon: Icon, label, value, sub }) {
  return (
    <div className="am-card p-6">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-widest text-muted-foreground font-bold">{label}</span>
        <div className="w-10 h-10 rounded-2xl bg-accent grid place-items-center"><Icon className="w-5 h-5 text-primary" /></div>
      </div>
      <div className="mt-4 font-display text-3xl font-extrabold">{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
    </div>
  );
}

export default function SubscriberDashboard() {
  const { t } = useT();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/subscriber/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <DashboardShell title="…" />;

  const inr = (n) => `₹ ${Number(n || 0).toLocaleString("en-IN")}`;
  return (
    <DashboardShell title={d.haat_name} subtitle={`${t("admin.plan")}: ${d.plan_id} · ${t("sub.helperLimit")}: ${d.helper_limit}`} action={<HelpVideoButton screen="getting_started" />}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        <Stat icon={Calendar} label={t("sub.todayCollection")} value={inr(d.today_collected)} sub={`${d.today_animals} ${t("sub.animalsCount")}`} />
        <Stat icon={IndianRupee} label={t("sub.allTime")} value={inr(d.total_collected)} />
        <Stat icon={Beef} label={t("sub.animalsInHaat")} value={d.in_haat} sub={`${d.total_animals} ${t("sub.animalsCount")}`} />
        <Stat icon={ShoppingBag} label={t("sub.soldAnimals")} value={d.sold} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mt-6">
        <Stat icon={UserPlus} label={t("sub.activeHelpers")} value={d.total_helpers} sub={`${t("sub.helperLimit")}: ${d.helper_limit}`} />
        <Stat icon={Users} label={t("sub.sellers")} value={d.total_sellers} />
        <Stat icon={Users} label={t("sub.purchasers")} value={d.total_purchasers} />
      </div>

      <GateActivityCard />

      <DailySummaryCard />

      <div className="am-card p-6 mt-6">
        <h2 className="font-display text-xl font-bold mb-4">{t("sub.feeConfig")}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            { l: t("sub.feeSeller"), v: inr(d.fee_seller_per_animal) },
            { l: t("sub.feePurchaser"), v: inr(d.fee_purchaser_per_animal) },
            { l: t("sub.feeGatepass"), v: inr(d.fee_gatepass) },
          ].map((x) => (
            <div key={x.l} className="bg-muted/40 rounded-2xl p-4">
              <div className="text-xs uppercase tracking-widest text-muted-foreground font-bold">{x.l}</div>
              <div className="font-display text-2xl font-extrabold mt-1">{x.v}</div>
            </div>
          ))}
        </div>
      </div>
    </DashboardShell>
  );
}
